import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonModal, IonPage, IonRow, IonText, IonTitle, isPlatform } from '@ionic/react';

import './Catalog.scss';
import { RouteComponentProps } from 'react-router';
import { useEffect, useRef, useState } from 'react';
import { AsyncAutocomplete, Header } from '../../components';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { RootState } from '../../data/store';
import { BarcodeScanner } from '@capacitor-mlkit/barcode-scanning';
import MLKitScanner from '../../components/mlKitScanner/MLKitScanner';
import { defaultScannerOptions, installGoogleBarcodeScannerModule, requestPermissions, urlToIdent } from '../../components/mlKitScanner/qrCodeHelper';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';

interface ArticleSearchForm {
  article: string | null
}

const ArticleIntro: React.FC<RouteComponentProps> = ({ history }) => {
  const [scanActive, setScanActive] = useState<boolean>(false);
  const modal = useRef<HTMLIonModalElement>(null!);
  const darkMode: boolean = useSelector((state: RootState) => state.user.darkMode);
  const [isScannerSupported, setIsScannerSupported] = useState(false);
  const { t } = useTranslation();


  /* wird vllt reset benötigt? siehe desh jobAutocomplete / JobDialog */
  const { control, handleSubmit, formState: { errors } } = useForm<ArticleSearchForm>({
    mode: "onTouched",
    reValidateMode: "onChange",
  });

  const onSubmit: SubmitHandler<ArticleSearchForm> = data => {
    //console.log(data.article?.split(" ").join(""))
    if (data.article) {
      history.push(`/tabs/article/productPriceAvail/sku1=${data.article.split(" ").join("")}`)
    }
  }

  useEffect(() => {
    let ignore = false;
    BarcodeScanner.isSupported().then((res) => {
      if (!ignore) {
        setIsScannerSupported(res.supported)
      }
    }).catch(() => { })
    return () => { ignore = true };
  }, [])

  const handleQRCodeResult = (url_string: string) => {
    let { searchStr } = urlToIdent(url_string)
    history.push(`/tabs/article/productPriceAvail/${searchStr}`);
  }

  const startScan = async () => {
    const granted = await requestPermissions();
    if (!granted) {
      //TODO: display error info
      return
    }
    if (isPlatform("android")) {
      const { available } = await BarcodeScanner.isGoogleBarcodeScannerModuleAvailable();
      if (!available) {
        await installGoogleBarcodeScannerModule()
      }
    }
    // Add the `barcodeScanned` listener
    await BarcodeScanner.addListener(
      'barcodesScanned',
      async result => {
        stopScan()
        handleQRCodeResult(result.barcodes[0].displayValue);// TODO: nach cap 7 update üebrprüfen was alles in array ist
      },
    )
    // Start the barcode scanner
    setScanActive(true)
    document.querySelector('body')?.classList.add('barcode-scanner-active');
    await BarcodeScanner.startScan(defaultScannerOptions);
  }

  const stopScan = async () => {
    document.querySelector('body')?.classList.remove('barcode-scanner-active');
    setScanActive(false)
    await BarcodeScanner.removeAllListeners();
    await BarcodeScanner.stopScan();
  };

  return (
    <IonPage>
      <Header>
        <IonTitle>{t("articleIntro.title")}</IonTitle>
      </Header>
      <IonContent fullscreen className={scanActive ? 'hideBg' : ''}>
        <IonGrid fixed={true} className="mainContent">
          <IonRow>
            <IonCol size="12">
              {/* Toolfinder Card */}
              <IonCard style={{ textAlign: "left", marginTop: 20 }}>
                <IonCardHeader>
                  <IonCardTitle>{t("articleIntro.toolfinderCardTitle")}</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                  <div className='scanCardContainer'>
                    <IonText>
                      {t("articleIntro.toolfinderCardText")}
                    </IonText>
                    <div className='scanImageContainer'>
                        <img className="scanImage" alt={t("articleIntro.toolfinderCardAlt")} src={darkMode ? `/assets/images/languageSpecific/${i18n.language}/search_dark.png` : `/assets/images/languageSpecific/${i18n.language}/search_light.png`} />
                    </div>
                  </div>
                  <IonButton style={{ marginTop: 16 }} routerLink='toolfinder' expand="block">{t("articleIntro.toolfinderCardBtn")}</IonButton>
                </IonCardContent>
              </IonCard>
            </IonCol>

            <IonCol size="12">
              <IonCard style={{ textAlign: "left" }}>
                <IonCardHeader>
                  <IonCardTitle>{t("articleIntro.priceCardTitle")}</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                  <IonText>{t("articleIntro.priceCardText")}</IonText>
                  <form>
                    <Controller
                      render={({ field: { onChange, onBlur, value } }) => (
                        <AsyncAutocomplete
                          onChange={onChange}
                          onBlur={onBlur}
                          value={value}
                        />
                      )}
                      control={control}
                      name="article"
                      defaultValue={null}
                      rules={{
                        required: { value: true, message: t("Feld darf nicht leer sein") },
                      }}
                    />
                    {/* @ts-ignore */}
                    {errors.ident && <div style={{ textAlign: "left", color: "#eb445a", fontSize: 14 }}>{errors.ident.message}</div>}
                    <IonButton style={{ marginTop: 16 }} onClick={handleSubmit(onSubmit)} expand="block">{t("articleIntro.priceCardBtn")}</IonButton>
                  </form>
                </IonCardContent>
              </IonCard>
            </IonCol>

            {/* Horizontale Variante */}
            <IonCol size="12">
              <IonCard style={{ textAlign: "left" }}>
                <IonCardHeader>
                  <IonCardTitle>{t("articleIntro.qrCardTitle")}</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                  <div className='scanCardContainer'>
                    <IonText>
                      {t("articleIntro.qrCardText")}
                    </IonText>
                    <div className='scanImageContainer'>
                      <img className="scanImage" alt={t("articleIntro.qrCardAlt")} src={darkMode ? "/assets/images/phone_dark.png" : "/assets/images/phone_light.png"} />
                    </div>
                  </div>
                  <div className='scannerBtn'>
                    <IonButton disabled={!isScannerSupported} expand="block" onClick={() => startScan()}>{t("articleIntro.qrCardBtn")}</IonButton>
                    {!isScannerSupported && <IonText className='centeredText'>{t("articleIntro.qrCardInfoText")}</IonText>}
                  </div>
                </IonCardContent>
              </IonCard>
            </IonCol>

          </IonRow>
        </IonGrid>

      </IonContent>
      <IonModal ref={modal} isOpen={scanActive} className="qrcodeScannerModal" onWillDismiss={() => stopScan()} canDismiss={true}>
        <MLKitScanner modal={modal} />
      </IonModal>
    </IonPage>
  );
};

export default ArticleIntro;

